import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Player } from "../../types/types";

// Define a type for the slice state
interface PlayersState {
  players: Array<Player>;
}

// Define the initial state using that type
const initialState: PlayersState = {
  players: [],
};

export const PlayersSlice = createSlice({
  name: "players",
  initialState,
  reducers: {
    setPlayers: (state, action: PayloadAction<Array<Player>>) => {
      state.players = action.payload;
    },
  },
});

export const { setPlayers } = PlayersSlice.actions;

export default PlayersSlice.reducer;
